import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface BadgeProps {
  children: ReactNode;
  variant?: 'green' | 'yellow' | 'red' | 'blue' | 'gray' | 'organic' | 'heirloom' | 'new';
  className?: string;
}

const variants = {
  // The `green` variant name is the public API; the colour behind it is the
  // semantic success ramp, which is deliberately not tenant-themed.
  green: 'bg-success-100 text-success-800 dark:bg-success-900/40 dark:text-success-200',
  yellow: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  red: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
  gray: 'bg-surface-muted text-ink-soft',
  organic: 'bg-sage-100 text-sage-800',
  heirloom: 'bg-amber-50 text-amber-900 dark:bg-amber-900/30 dark:text-amber-100',
  new: 'bg-orange-50 text-terra-dark dark:bg-orange-900/30',
};

export default function Badge({ children, variant = 'gray', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
